import './parts/premium-partners.js';
import './parts/header.js';
import './parts/widget.js';
import './parts/youtube-iframes.js';

( function( $ ) {
    $.fn.inputFilter = function( inputFilter ) {
        return this.on( "input keydown keyup mousedown mouseup select contextmenu drop", function() {
            if ( inputFilter( this.value ) ) {
                this.oldValue = this.value;
                this.oldSelectionStart = this.selectionStart;
                this.oldSelectionEnd = this.selectionEnd;
            } else if ( this.hasOwnProperty( "oldValue" ) ) {
                this.value = this.oldValue;
                this.setSelectionRange( this.oldSelectionStart, this.oldSelectionEnd );
            }
        } );
    };
}( jQuery ) );

function timer() {
    jQuery( "[data-counter]" ).each( function( index ) {
        var interval = jQuery( this ).data( "interval" );
        if ( interval && interval !== "" ) {
            var seconds = parseInt( interval );
            var days = Math.floor( seconds / 24 / 60 / 60 );
            var hoursLeft = Math.floor( ( seconds ) - ( days * 86400 ) );
            var hours = Math.floor( hoursLeft / 3600 );
            var minutesLeft = Math.floor( ( hoursLeft ) - ( hours * 3600 ) );
            var minutes = Math.floor( minutesLeft / 60 );
            var remainingSeconds = seconds % 60;

            function pad( n, add ) {
                if ( add > 0 ) {
                    n = n + add;
                }
                return ( n < 10 ? "0" + n : n );
            }

            jQuery( this ).find( '[data-counter-days]' ).text( pad( days, 0 ) );
            jQuery( this ).find( '[data-counter-hours]' ).text( pad( hours, 0 ) );
            jQuery( this ).find( '[data-counter-minutes]' ).text( pad( minutes, 1 ) );
            if ( seconds == 0 ) {
                //nothing happens
            } else {
                seconds--;
                jQuery( this ).data( "interval", seconds );
            }
        }
    } );
}

function findGetParameter( parameterName ) {
    var result = null,
        tmp = [];
    location.search
        .substr( 1 )
        .split( "&" )
        .forEach( function( item ) {
            tmp = item.split( "=" );
            if ( tmp[0] === parameterName )
                result = decodeURIComponent( tmp[1] );
        } );
    return result;
}

jQuery( document ).ready( function( $ ) {
    /*var maxwidth = 0;
     $('.equal-buttons-formulae').find('.button').each(function () {
     if(parseInt($(this).outerWidth(true)) > maxwidth) {
     maxwidth = parseInt($(this).outerWidth(true));
     }
     });
     maxwidth+=1;
     $('.equal-buttons-formulae .button').css("width", maxwidth+"px");*/

    $( '.js-select-filter' ).select2( {
        minimumResultsForSearch: -1,

        // dropdownParent: $('div#page')
    } );

    $( '.header-select' ).select2( {
        minimumResultsForSearch: -1
    } );

    $( '.dropdown' ).each( function() {
        var t = null;
        var dropdown = $( this );
        dropdown.hover( function() {
            t = setTimeout( function() {
                if ( dropdown.find( ".header-circuits" ).length == 0 ) {
                    if ( $( '.header-circuits .select2-container' ).hasClass( 'select2-container--open' ) ) {
                        $( '.header-select' ).select2( 'close' );
                        $( '.circuits-dropdown' ).find( '.dropdown-content' ).slideUp( 200, function() {
                            dropdown.find( ".dropdown-content" ).slideDown( 300 );
                        } );
                    } else {
                        dropdown.find( ".dropdown-content" ).slideDown( 300 );
                    }
                } else {
                    dropdown.find( ".dropdown-content" ).slideDown( 300 );
                }
                t = null;
            }, 300 );
        }, function() {
            if ( t ) {
                clearTimeout( t );
                t = null;
            } else {
                if ( dropdown.find( ".burger" ).length > 0 ) {
                    setTimeout( function() {
                        if ( $( '#burgerdp:hover' ).length === 0 ) {
                            dropdown.find( ".dropdown-content" ).slideUp( 200 );
                        } else {
                        }
                    }, 800 );
                } else {
                    if ( $( '.header-circuits .select2-container' ).length > 0 ) {
                        if ( $( '.header-circuits .select2-container' ).hasClass( 'select2-container--open' ) ) {
                        } else {
                            dropdown.find( ".dropdown-content" ).slideUp( 200 );
                        }
                    } else {
                        dropdown.find( ".dropdown-content" ).slideUp( 200 );
                    }
                }
            }
        } );
    } );

    $( '.header-select' ).on( 'select2:close', function( e ) {
        setTimeout( function() {
            if ( $( '.circuits-dropdown:hover' ).length === 0 ) {
                $( '.circuits-dropdown' ).find( '.dropdown-content' ).slideUp( 200 );
            }
        }, 300 );
    } );

    setInterval( function() {
        /*if ($('.header-circuits .select2-container').length > 0) {
         if ($('.header-circuits .select2-container').hasClass('select2-container--open')) {
         $('.header-circuits').closest('.dropdown').addClass("hovered");
         $('.header-circuits').closest('.dropdown-content').css({"display": "block", "margin": "40px 0"});
         } else {
         $('.header-circuits').closest('.dropdown').removeClass("hovered");
         $('.header-circuits').closest('.dropdown-content').css({"display": "", "margin": ""});
         }
         }*/
    }, 100 );

    $( document ).on( "click", ".reset-filters-buttons", function( e ) {
        e.preventDefault();

        $( '#switcher' ).prop( 'checked', false ); // Unchecks it
        $( '#switcher' ).attr( 'checked', false ); // Unchecks it
        $( ".m_switch" ).removeClass( 'm_switch_color' );
        $( ".m_switch_b" ).removeClass( 'm_switch_checked' );
        $( "#year-selection" ).removeClass( 'year-selection' );
        $( '.js-select-filter' ).val( 'default' ).trigger( "change" );


        $( '.js-text-filter' ).val( '' );
        localStorage.setItem( 'classified-categories-select', 'default' );
        localStorage.setItem( 'classified-price-select', 'default' );
        localStorage.setItem( 'classified-categories-text', '' );
    } );

    $( '.classified-categories-select' ).change( function() {
        localStorage.setItem( 'classified-categories-select', this.value );
    } );
    $( '.classified-price-select' ).change( function() {
        localStorage.setItem( 'classified-price-select', this.value );
    } );
    $( '.classified-categories-text' ).change( function() {
        localStorage.setItem( 'classified-categories-text', this.value );
    } );
    if ( $( '.classified-categories-select' ).length > 0 ) {
        var loadFrom = findGetParameter( 'load_filters' );
        if ( loadFrom ) {
            if ( localStorage.getItem( 'classified-categories-select' ) ) {
                $( '.classified-categories-select' ).val( localStorage.getItem( 'classified-categories-select' ) );
            }
            if ( localStorage.getItem( 'classified-price-select' ) ) {
                $( '.classified-price-select' ).val( localStorage.getItem( 'classified-price-select' ) );
            }
            if ( localStorage.getItem( 'classified-categories-text' ) ) {
                $( '.classified-categories-text' ).val( localStorage.getItem( 'classified-categories-text' ) );
            }
            $( '.classified-categories-select' ).trigger( 'change' );
        } else {
            localStorage.setItem( 'classified-categories-select', 'default' );
            localStorage.setItem( 'classified-price-select', 'default' );
            localStorage.setItem( 'classified-categories-text', '' );
        }
    }


    function ajaxGetItems( url, page, post, type ) {
        $( '.filtering-container' ).text( '' );
        $( '.pagination-ajax' ).html( '' );
        appendLoader( '.filtering-container' );
        $.post( url + page, post )
            .done( function( data ) {
                if ( data ) {
                    if ( data.length === 0 ) {
                        $( '.pagination-ajax' ).html( '' );
                        removeLoader( '.filtering-container' );
                    }

                    if ( $( '#switcher' ).prop( "checked" ) == false ) {
                        var showhide = "hide";
                    }

                    $.each( data, function( index, value ) {
                        if ( type === "events" ) {
                            let image = "";
                            if ( value["image"] ) {
                                image = 'background-image:url(\'' + value["image"] + '\');';
                            }
                            const event_link = `<a href="${value['permalink']}" class="button" rel="bookmark">Event Info</a>`;
                            const entry_link = value['show_entry_link'] && value['racehub_link'] ?
                                `<a href="${value['racehub_link']}" class="button button--racehub">Enter Now</a>` :
                                ``;
                            const start_date = value['start_date'].replace( value['start_year'], '' );
                            const end_date = value['end_date'];
                            $( '.filtering-container' ).append(
                                '<article class="third arch_event">' +
                                '<div class="col">' +
                                '<a href="' + value["permalink"] + '" title="Permalink to ' + value["title"] + '" rel="bookmark">' +
                                '<div class="feat">' +
                                '<div style="' + image + '"></div>' +
                                '</div>' +
                                '</a>' +
                                '</div>' +
                                '<div class="col content">' +
                                '<hgroup class="content--small">' +
                                '<p class="heading--s-small jam up"><b>' + value["circuit"] + ' ' + value["circuit_type"] + '</b></p>' +
                                '<h4 class="heading--medium up">' + value["title"] + '</h4>' +
                                '</hgroup>' +
                                '<p>' +
                                value['description'] + `... <a href="${value['permalink']}" rel="bookmark">Read More</a>` +
                                '</p>' +
                                '</div>' +
                                '<div class="col">' +
                                '<p class="arch_event__date jam heading--small up bold">' +
                                start_date + ' -<br>' + end_date +
                                '</p >' +
                                '<div class="arch_event__buttons">' +
                                event_link +
                                entry_link +
                                '</div>' +
                                '</div>' +
                                '</article>' );
                        } else if ( type === "circuits" ) {
                            var image = "";
                            if ( value["circuit_outline"] ) {
                                image = 'background-image:url(\'' + value["circuit_outline"] + '\');';
                            }
                            var next_event =
                                '<div class="mini_next_event jam">' +
                                '<p class="m-0">next event</p>' +
                                '<p class="m-0"><b>' +
                                ( ( value["next_event_start"] && value["next_event_end"] ) ?
                                    value["next_event_start"] + ' - ' + value["next_event_end"] :
                                    "TBC" ) +
                                '</b></p>' +
                                '</div>';
                            $( '.filtering-container' ).append(
                                '<article class="card--circuit col" style="border-bottom:0px;">' +
                                '<a href="' + value["permalink"] + '" title="Permalink to ' + value["title"] + '" rel="bookmark">' +
                                '<div class="mb20">' +
                                '<div class="feat feat--circuit">' +
                                '<div style="' + image + '"></div>' +
                                '</div>' +
                                '</div>' +
                                '</a>' +
                                '<a href="' + value["permalink"] + '" title="Permalink to ' + value["title"] + '" rel="bookmark">' +
                                '<h4><b>' + value["title"] + ' ' + value["circuit_type"] + '</b></h4>' +
                                '</a>' + next_event +
                                '<p>' +
                                value['description'] + `... <a href="${value['permalink']}" rel="bookmark">Read More</a>` +
                                '</p>' +
                                '</article>' );
                        } else if ( type === "formulae" ) {
                            var image = "";
                            if ( value["image"] ) {
                                image = 'background-image:url(\'' + value["image"] + '\');';
                            }
                            var next_event = "";
                            if ( value["next_event_start"] && value["next_event_end"] && value["event_name"] ) {
                                next_event =
                                    '<div class="mini_next_event jam">' +
                                    '<p>next event</p>' +
                                    '<p><b>' + value["next_event_start"] + ' - ' + value["next_event_end"] + '</b></p>' +
                                    '<p>' + value["event_name"] + '</p>' +
                                    '</div>';
                            }
                            $( '.filtering-container' ).append(
                                '<article class="card--formulae">' +
                                '<a href="' + value["permalink"] + '" title="Permalink to ' + value["title"] + '" rel="bookmark">' +
                                '<div class="feat mb20" style="width:auto">' +
                                '<div style="' + image + '"></div>' +
                                '</div>' +
                                '</a>' +
                                '<a href="' + value["permalink"] + '" title="Permalink to ' + value["title"] + '" rel="bookmark">' +
                                '<h4><b>' + value["title"] + '</b></h4>' +
                                '</a>' + next_event +
                                '<p class="formula-excerpt m-0">' + value['description'] +
                                `... <a href="${value['permalink']}" rel="bookmark">Read More</a>` +
                                '</p>' +
                                '</article>' );
                        } else if ( type === "classifieds" ) {
                            var image = "";
                            if ( value["image"] ) {
                                image = value["image"];
                            }
                            $( '.filtering-container' ).append(
                                '<article class="card--classified">' +
                                '<a href="' + value["permalink"] + '" title="Permalink to ' + value["title"] + '" rel="bookmark">' +
                                '<div class="feat">' +
                                '<div style="background-image:url(\'' + image + '\');"></div>' +
                                '</div>' +
                                '</a>' +
                                '<span class="classified-price jam">' + value["price"] + '</span>' +
                                '<a href="' + value["permalink"] + '" title="Permalink to ' + value["title"] + '" rel="bookmark" class="classifieds-page-link">' +
                                '<h4><b>' + value["title"] + '</b></h4>' +
                                '</a>' +
                                '<p class="m-0">' + value['description'] +
                                `... <a href="${value['permalink']}" rel="bookmark">Read More</a>` +
                                '</p>' +
                                '</article>' );
                        }
                        removeLoader( '.filtering-container' );
                        formulae_dashes();
                        var nav = value['nav'];
                        if ( nav !== null ) {
                            $( '.pagination-ajax' ).html( nav );
                        } else {
                            $( '.pagination-ajax' ).html( '' );
                        }
                    } );
                    if ( type === "circuits" ) {
                        $( '.filtering-container' ).find( '.col' ).wrapAll( '<div class=\'formula_row\' />' );
                    }
                    //}
                } else {
                    $( '.pagination-ajax' ).html( '' );
                }

                if ( data.length === 0 && ( $( '#switcher' ).prop( "checked" ) == false ) ) {
                    $( '.filtering-container' ).append( '<span class="nothing-found-filter">no search results</span><small class="centerF">If you are looking for past events please turn on the include past events</small>' );
                } else if ( data.length === 0 ) {
                    $( '.filtering-container' ).append( '<span class="nothing-found-filter">no search results</span>' );
                }

                $( ".pagination-ajax" ).addClass( "ajaxed" );
                $( ".filtering-container" ).data( "locked", "false" );
            } );
        //removeLoader('.events_archive');
    }

    function appendLoader( container ) {
        $( container ).html( '<div class="loader_upcoming">' +
            '<div id="floatingCirclesG">' +
            '<div class="f_circleG" id="frotateG_01"></div>' +
            '<div class="f_circleG" id="frotateG_02"></div>' +
            '<div class="f_circleG" id="frotateG_03"></div>' +
            '<div class="f_circleG" id="frotateG_04"></div>' +
            '<div class="f_circleG" id="frotateG_05"></div>' +
            '<div class="f_circleG" id="frotateG_06"></div>' +
            '<div class="f_circleG" id="frotateG_07"></div>' +
            '<div class="f_circleG" id="frotateG_08"></div>' +
            '</div>' +
            '</div>' );
        var el = $( ".loader_upcoming" );
        var elementTop = el.offset().top;
        var elementBottom = elementTop + el.outerHeight();

        var viewportTop = $( window ).scrollTop();
        var viewportBottom = viewportTop + $( window ).height();

        var inViewPort = elementBottom > viewportTop && elementTop < viewportBottom;
        if ( !inViewPort ) {
            $( 'html, body' ).animate( {
                scrollTop: ( el.offset().top - 140 )
            }, 500 );
        }
    }

    function removeLoader( container ) {
        $( container ).find( ".loader_upcoming" ).remove();
    }

    //ajax filteres
    $( '.js-select-filter' ).on( "change", function( e ) {
        //circuit
        const url = $( ".filtering-container" ).data( "url" );
        const type = $( ".filtering-container" ).data( "type" );
        const locked = $( ".filtering-container" ).data( "locked" );

        if ( typeof url !== "undefined" && typeof type !== "undefined" && locked !== "true" ) {
            $( ".filtering-container" ).data( "locked", "true" );
            const post = {};
            $( '.reset-filters-buttons' ).css( 'display', 'none' );
            $( '.js-select-filter' ).each( function( index ) {
                if ( $( this ).val() !== 'default' ) {
                    $( '.reset-filters-buttons' ).css( 'display', 'inline-block' );
                }
                post[$( this ).attr( "name" )] = $( this ).val();
            } );
            $( '.js-text-filter' ).each( function( index ) {
                if ( $( this ).val() !== '' ) {
                    $( '.reset-filters-buttons' ).css( 'display', 'inline-block' );
                }
                post[$( this ).attr( "name" )] = $( this ).val();
            } );
            ajaxGetItems( url, "1", post, type );
        }
    } );

    $( '.classified-categories-search' ).on( "submit", function( e ) {
        e.preventDefault();
        var url = $( ".filtering-container" ).data( "url" );
        var type = $( ".filtering-container" ).data( "type" );
        var locked = $( ".filtering-container" ).data( "locked" );
        if ( typeof url !== "undefined" && typeof type !== "undefined" && locked !== "true" ) {
            $( ".filtering-container" ).data( "locked", "true" );
            var post = {};
            $( '.reset-filters-buttons' ).css( 'display', 'none' );
            $( '.js-select-filter' ).each( function( index ) {
                if ( $( this ).val() !== 'default' ) {
                    $( '.reset-filters-buttons' ).css( 'display', 'inline-block' );
                }
                post[$( this ).attr( "name" )] = $( this ).val();
            } );
            $( '.js-text-filter' ).each( function( index ) {
                if ( $( this ).val() !== '' ) {
                    $( '.reset-filters-buttons' ).css( 'display', 'inline-block' );
                }
                post[$( this ).attr( "name" )] = $( this ).val();
            } );
            ajaxGetItems( url, "1", post, type );
        }
    } );

    $( document ).on( "click", ".ajaxed .page-numbers", function( e ) {
        e.preventDefault();
        var url = $( ".filtering-container" ).data( "url" );
        var type = $( ".filtering-container" ).data( "type" );
        if ( typeof url !== "undefined" && typeof type !== "undefined" ) {
            if ( !$( this ).hasClass( 'current' ) ) {
                $( '.current' ).removeClass( 'current' );
                $( this ).addClass( 'current' );
                var page = 0;
                if ( $( this ).attr( 'href' ) ) {
                    var pageh = /page\/(\d+)/gm;
                    var matches = $( this ).attr( 'href' ).match( pageh );
                    if ( matches.length > 0 ) {
                        page = matches[0].replace( "page/", "" );
                    }
                } else {
                    if ( !isNaN( $( this ).text() ) ) {
                        page = $( this ).text();
                    }
                }
                if ( page > 0 ) {
                    $( ".filtering-container" ).data( "locked", "true" );
                    var post = {};
                    $( '.js-select-filter' ).each( function( index ) {
                        post[$( this ).attr( "name" )] = $( this ).val();
                    } );
                    $( '.js-text-filter' ).each( function( index ) {
                        post[$( this ).attr( "name" )] = $( this ).val();
                    } );
                    ajaxGetItems( url, page, post, type );
                }
            }
        }
    } );

    if ( $( '.cont table' ).length > 0 ) {
        $( '.cont table' ).wrap( $( "<div />" ).css( { "overflow-x": "auto", "display": "block" } ) );
        $( '.cont table' ).parent().before( "<div class='table-tooltip'>you can scroll left to right or best viewed in landscape</div>" );
    }

    if ( $( 'table.cevents' ).length > 0 ) {
        $( 'table.cevents' ).wrap( $( "<div />" ).css( { "overflow-x": "auto", "display": "block" } ) );
        $( 'table.cevents' ).parent().before( "<div class='table-tooltip'>you can scroll left to right or best viewed in landscape</div>" );
    }

    $( '.select2-selection__arrow b[role="presentation"]' ).hide();
    $( '.select2-selection__arrow' ).append( '<i class="fas fa-angle-down"></i>' );

    $( '.js-select-filter' ).each( function( i ) {
        if ( $( this ).val() !== 'default' ) {
            $( this ).trigger( "change" );
        }
    } );

    //start timers
    var countdownTimer = setInterval( timer, 1000 );

    const mediaSmall = window.matchMedia( '(min-width: 640px)' );
    let mobileTabsActive = false;

    $( document ).on( "click", ".tab-link", function( e ) {
        e.preventDefault();
        $( this ).closest( ".tabs-wrapper" ).find( ".active-tab" ).removeClass( "active-tab" );
        $( this ).addClass( "active-tab" );
        $( this ).closest( ".tabs-wrapper" ).find( ".active-content" ).removeClass( "active-content" );
        var tab = $( this ).find( 'a' ).attr( "href" );
        if ( typeof tab !== undefined ) {
            $( tab ).addClass( "active-content" );
        }
    } );

    setMobileTabFunctionality();
    window.addEventListener( 'resize', setMobileTabFunctionality, { passive: true } );

    $.fn.isInViewport = function() {
        var elementTop = $( this ).offset().top;
        var elementBottom = elementTop + $( this ).outerHeight();

        var viewportTop = $( window ).scrollTop();
        var viewportBottom = viewportTop + $( window ).height();

        return elementBottom > viewportTop && elementTop < viewportBottom;
    };

    $( document ).on( "click", ".accordion-link", function( e ) {
        $( this ).closest( ".accordion-wrapper" ).find( ".active-accordion" ).removeClass( "active-accordion" );
        if ( $( this ).next( ".accordion-content" ).is( ':visible' ) ) {
            $( this ).parent().find( ".accordion-content" ).slideUp( 300 );
            //$(this).addClass("active-accordion");
        } else {
            if ( $( this ).parent().find( '.accordion-content' ).is( ':visible' ) ) {
                $( this ).parent().find( ".accordion-content" ).slideUp( 300 );
            }
            var el = $( this );
            $( this ).next( ".accordion-content" ).slideDown( 300, function( e ) {
                if ( !el.isInViewport() ) {
                    $( 'html, body' ).animate( {
                        scrollTop: ( el.offset().top - 70 )
                    }, 500 );
                }
            } );
            /*$([document.documentElement, document.body]).animate({
             scrollTop: $(this).offset().top
             }, 2000);*/
            $( this ).addClass( "active-accordion" );
        }
        //$(this).addClass("active-accordion");
    } );

    $( window ).resize( function() {
        /*if(window.screen.width > 1024) {
         $(".tabs-wrapper").each(function (i) {
         var height = 0;
         $(this).find('.tab-link').each(function(k) {
         if(parseInt($(this).outerHeight()) > height) {
         height = parseInt($(this).outerHeight());
         }
         });
         if (height > 0) {
         //var height = parseInt($(".tabs-switchers").outerHeight());
         console.log("height: "+height);
         $(this).find('.tab-link').each(function(k) {
         console.log("outerHeight: "+parseInt($(this).outerHeight()));
         if(parseInt($(this).outerHeight()) < height) {
         var diff = height - parseInt($(this).outerHeight());
         console.log("diff: "+diff);
         if(diff > 1) {
         var padding = diff / 2;
         var current_padding = ($(this).find("span").outerHeight()-$(this).find("span").height())/2;
         var final_padding = parseInt(padding + current_padding);
         console.log("padding: "+final_padding);
         $(this).find("span").css({"padding": final_padding+"px 0", "display": "inline-block"});
         $(this).css("bottom",final_padding+"px");
         }
         }
         });
         $(".tabs-switchers").css("max-height", height+"px");
         }
         });
         }*/
        /*tabs resize*/
        if ( window.screen.width > 1024 ) {
            $( ".tabs-wrapper" ).each( function( i ) {
                var height = 0;
                $( this ).find( '.tab-link a span' ).each( function( k ) {
                    if ( parseInt( $( this ).innerHeight() ) > height ) {
                        height = parseInt( $( this ).innerHeight() );
                    }
                } );
                if ( height > 0 ) {
                    $( this ).find( '.tab-link a span' ).each( function( k ) {
                        var diff = 15 + height - parseInt( $( this ).innerHeight() );
                        if ( diff > 0 ) {
                            $( this ).parent().css( "padding-top", diff + "px" );
                        }
                    } );
                }
            } );
        }
        /* grid bottom border */
        formulae_dashes();

        /* homepage news vertical align */
        if ( ( window.screen.width > 1024 ) && ( $( ".news-caption" ).length > 0 ) ) {
            var newsheight = $( ".news-caption" ).parent().height();
            var spannews = $( ".news-caption" ).find( 'span' ).height();
            var newspaddings = ( newsheight - spannews ) / 2;
            $( ".news-caption" ).css( "padding", newspaddings + "px 0" );
        }

        /* formulae button align */
        if ( ( window.screen.width > 1024 ) && ( $( ".contact-info .button" ).length > 0 ) && ( $( ".official-sns .button" ).length > 0 ) ) {
            var topc = $( ".contact-info .button" ).first().position().top;
            var toph = $( ".official-sns .button" ).first().position().top;
            var sns = topc - toph;
            $( ".official-sns" ).first().css( "top", sns + "px" );
        }
    } ).resize();

    function formulae_dashes() {
        if ( $( ".formula_dividers" ).length > 0 ) {
            var column_num = Math.floor( parseInt( $( ".formula_layout" ).width() ) / parseInt( $( ".formula_layout .col" ).width() ) );
            if ( column_num == 1 ) {
                $( '.formula_layout .col' ).css( "border-bottom", "1px solid #838283" );
                $( '.formula_layout .col' ).css( "margin-bottom", "" );
                $( '.formula_layout .col' ).slice( -Math.abs( 1 ) ).css( "border-bottom", "none" );
                $( '.formula_layout .col' ).slice( -Math.abs( 1 ) ).css( "margin-bottom", "0 !important" );
            } else if ( column_num > 0 ) {
                var borderless = 12 - $( ".formula_layout .col" ).length;
                var columns = $( ".formula_layout .col" ).length % column_num;
                if ( columns == 0 ) {
                    var end = column_num - borderless;
                    if ( end > 0 ) {
                        $( '.formula_layout .col' ).css( "border-bottom", "1px solid #838283" );
                        $( '.formula_layout .col' ).css( "margin-bottom", "" );
                        $( '.formula_layout .col' ).slice( -Math.abs( end ) ).css( "border-bottom", "none" );
                        $( '.formula_layout .col' ).slice( -Math.abs( end ) ).css( "margin-bottom", "0 !important" );
                    } else {
                        $( '.formula_layout .col' ).css( "border-bottom", "none" );
                        $( '.formula_layout .col' ).css( "margin-bottom", "0 !important" );
                    }
                } else {
                    $( '.formula_layout .col' ).css( "border-bottom", "1px solid #838283" );
                    $( '.formula_layout .col' ).css( "margin-bottom", "" );
                    $( '.formula_layout .col' ).slice( -Math.abs( columns ) ).css( "border-bottom", "none" );
                    $( '.formula_layout .col' ).slice( -Math.abs( columns ) ).css( "margin-bottom", "0 !important" );
                }
            } else {
                $( '.formula_layout .col' ).css( "border-bottom", "1px solid #838283" );
                $( '.formula_layout .col' ).css( "margin-bottom", "" );
            }
        }
    }

    if ( window.screen.width > 1024 ) {
        $( ".live-timing-padding" ).each( function( e ) {
            var padding = ( $( this ).parent().outerHeight() - $( this ).find( ".button" ).outerHeight() ) / 2;
            $( this ).css( "padding", padding + "px 0" );
        } );
    }

    if ( $( ".ap-pro-form-field input[name=price]" ).length > 0 ) {
        $( ".ap-pro-form-field input[name=price]" ).attr( "type", "number" );
        $( ".ap-pro-form-field input[name=price]" ).css( "width", "100%" );
    }

    $( ".ap-pro-front-form" ).submit( function( e ) {
        //e.preventDefault();
        var $input = $( this ).find( "input[name=price]" );
        if ( $input.val() != 'undefined' ) {
            $input.val( $input.val().replace( /\./g, "" ) );
        }
        //email duplicate
        var $email = $( this ).find( "input[name=ap_form_author_email]" );
        if ( ( $email.val() != 'undefined' ) && ( $( this ).find( "input[name=email]" ).length > 0 ) ) {
            $( this ).find( "input[name=email]" ).val( $email.val() );
        }
    } );

    $( '#mc4wp-form-1' ).on( 'submit', function( evt ) {
        evt.preventDefault();
        var el = $( this );
        if ( !el.hasClass( 'form-processing' ) ) {
            el.addClass( 'form-processing' );
            el.find( '.subscription-alert' ).remove();
            el.find( 'input[type=submit]' ).val( "Loading..." );
            var linkToPost = window.location.href;
            $.post( linkToPost, $( '#mc4wp-form-1' ).serialize() )
                .done( function( data ) {
                    var $result = $( data ).find( '.mc4wp-response' ).text();
                    el.prepend( "<div class='subscription-alert'>" + $result + "</div>" );
                    el.removeClass( 'form-processing' );
                    el.find( 'input[type=submit]' ).val( 'SIGN UP' );
                } );
        }
    } );


    function setMobileTabFunctionality() {
        if ( mediaSmall.matches && mobileTabsActive ) {
            breakdownMobileTabs();
        } else if ( !mediaSmall.matches && !mobileTabsActive ) {
            setUpMobileTabs();
        }
    }

    function setUpMobileTabs() {
        $( document ).on( 'click', '.tab-link', placeTabContent );
        document.querySelectorAll( '.active-tab' ).forEach( tab => {
            const tabGroup = tab.closest( '.formulae-tabs' );
            const tabContent = tabGroup.querySelector( '.tabs-content' );
            tab.after( tabContent );
        } );
        mobileTabsActive = true;
    }

    function breakdownMobileTabs() {
        const tabGroups = document.querySelectorAll( '.formulae-tabs' );
        tabGroups.forEach( group => {
            const tabContent = group.querySelector( '.tabs-content' );
            const tabSwitches = group.querySelector( '.tabs-wrapper' );
            tabSwitches.append( tabContent );
        } );
        $( document ).off( 'click', '.tab-link', placeTabContent );
        mobileTabsActive = false;
    }

    function placeTabContent() {
        const tabGroup = this.closest( '.formulae-tabs' );
        const tabContent = tabGroup.querySelector( '.tabs-content' );
        this.after( tabContent );
        this.scrollIntoView();
    }
} );


( function( $ ) {
    $( document ).on( 'ready', function() {
        $( ".m_switch_check:checkbox" ).mSwitch( {
            onRendered: function() { },
            onRender: function( elem ) { },

            onTurnOn: function( elem ) {
                $( '#dynamicChange' ).val( 'old' ).trigger( 'change' );
                $( "#year-selection" ).addClass( 'year-selection' );
            },

            onTurnOff: function( elem ) {
                $( '#year-selection , #dynamicChange' ).val( 'default' ).trigger( 'change' );
                $( "#year-selection" ).removeClass( 'year-selection' );
            }
        } );

        $( ".m_switch" ).wrap( "<div class='event-switcher'></div>" );
        $( "<p class='ep'>Include Past Events</p>" ).insertBefore( ".m_switch" );

        const isChecked = $( '#switcher:checked' ).val() ? true : false;
        if ( isChecked == true ) {
            $( "#year-selection" ).addClass( 'year-selection' );
        } else {
            $( "#year-selection" ).removeClass( 'year-selection' );
        }

        document.querySelector( '.wpcf7-submit' )?.addEventListener( 'click', function( event ) {
            document.querySelector( "form.wpcf7-form .wpcf7-submit" ).value = 'Processing your tickets…';
        }, false );

        document.addEventListener( 'wpcf7invalid', function( event ) {
            document.querySelector( "form.wpcf7-form .wpcf7-submit" ).value = 'Submit';
        }, false );

        document.addEventListener( 'wpcf7mailsent', function( event ) {
            document.querySelectorAll( "form.wpcf7-form > :not(.wpcf7-response-output)" ).forEach( el => {
                if ( el.innerHTML == 'Get your free tickets' ) {
                    el.innerHTML = 'We look forward to seeing you at the BRSCC Driven By Racing event';
                } else {
                    el.style.display = 'none';
                }
            } );

            document.querySelector( ".wpcf7-form" ).scrollIntoView( { behavior: "smooth", block: "center" } );
        }, false );
    } );
} )( jQuery );


